import {
  createFileRoute,
  Link,
  Outlet,
  redirect,
} from '@tanstack/react-router';
import { getSession } from '@/services/get-session';
import { roleCan } from '@listening/auth/permissions';
import { ScrollArea } from '@listening/frontend/components/radix/scroll-area';
import { Predicate } from 'effect';

export const Route = createFileRoute('/app/_authenticated/admin')({
  beforeLoad: async () => {
    const check = await getSession();
    // Fail closed on `Unavailable`: privileged UI stays hidden unless admin
    // app access is positively verified. On SSR that verification can come
    // from the signed cookie cache, so a revoked role holds this shell for
    // at most the cache maxAge; admin data and mutations still authorize
    // per-request at the API (auth-middleware requiredRole).
    if (
      !Predicate.isTagged(check, 'Authenticated') ||
      !roleCan(check.session.role, { adminApp: ['access'] })
    ) {
      throw redirect({ to: '/app/home' });
    }
  },
  component: AdminLayout,
});

function AdminLayout() {
  return (
    <ScrollArea className='h-full bg-gray-50 dark:bg-navy-860'>
      <header className='border-b border-gray-200 bg-white px-6 py-4 dark:border-navy-260 dark:bg-navy-760'>
        <div className='flex items-center justify-between'>
          <h1 className='text-xl font-semibold text-gray-900 dark:text-white'>
            Admin Panel
          </h1>
          <Link
            to='/app/home'
            className='text-sm text-gray-500 hover:text-gray-700 dark:text-steel-180 dark:hover:text-white'
          >
            Back to app
          </Link>
        </div>
      </header>
      <div className='mx-auto max-w-5xl px-6 py-8'>
        <Outlet />
      </div>
    </ScrollArea>
  );
}
